import PropTypes from 'prop-types'

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  entity: PropTypes.object,
}

export default propTypes
